export const getPrice = price =>
  Intl.NumberFormat(undefined, {
    currency: 'EUR',
    minimumFractionDigits: 2,
    style: 'currency'
  }).format(parseFloat(price || 0))
